import React, { useState } from "react";
import InputField from "./InputField";
import TextAreaField from "./TextAreaField";
import SimpleTickbox from "./SimpleTickBox";
import SelectField from "./SelectField";

export function renderFormField(
  field,
  formState,
  handleInputChange,
  loading,
  formSubmitted,
  errors ,
) {
  const fieldId = field.label.toLowerCase().replace(/\s+/g, "_");

  const ErrorMessage = () => (
    formSubmitted && errors && errors[fieldId] ? (
      <p className="text-red-500 text-xs mt-1">{errors[fieldId]}</p>
    ) : null
  );

  switch (field.type) {
    case "input":
      return (
        <div className="flex flex-col" key={field.id}>
          <InputField
            id={fieldId}
            name={fieldId}
            label={field.label}
            value={formState[fieldId] || ""}
            onChange={handleInputChange}
            disabled={loading}
            required={field.required}
            type={field.inputType || "text"}
          />
           <ErrorMessage />
        </div>
      );

    case "textarea":
      return (
        <div className="flex flex-col" key={field.id}>
          <TextAreaField
            id={fieldId}
            name={fieldId}
            label={field.label}
            value={formState[fieldId] || ""}
            onChange={handleInputChange}
            disabled={loading}
            required={field.required}
            formSubmitted={formSubmitted}
          />
           <ErrorMessage />
        </div>
      );

    case "checkbox":
      return (
        <div key={field.id}>
          <SimpleTickbox
            id={fieldId}
            name={fieldId}
            label={field.label}
            checked={formState[fieldId] || false}
            onChange={handleInputChange}
            disabled={loading}
          />
           <ErrorMessage />
        </div>
      );
    case "select":
      return (
        <div className="flex flex-col" key={field.id}>
          {console.log("Select field:", field)}
          <SelectField
            id={fieldId}
            name={fieldId}
            label={field.label}
            value={formState[fieldId] || ""}
            onChange={handleInputChange}
            disabled={loading}
            required={field.required}
            options={field.options}
          />
           <ErrorMessage />
        </div>
      );

    case "disclaimer":
      return (
        <div className="flex flex-col" key={field.id}>
          <p className="text-sm text-gray-600 mt-2 mb-4">{field.label}</p>
        </div>
      );

    default:
      return null;
  }
}

export default renderFormField;
